import { useState } from 'react'
import classnames from 'classnames/bind'
import Slider from 'react-rangeslider'

// Libs
import { isMobile2 } from '@/utils/navigator'

// Components
import ActionIcon from '@/components/common/ActionIcon'
import Icon from '@/assets/icons'

// Constants

// Styles
import styles from './style.module.scss'
import 'react-rangeslider/lib/index.css'

const cx = classnames.bind(styles)

interface PropsType {
  className?: string
  iconClassname?: string
  soundValue: number
  handleSoundTouchEnd?: any
  handleSoundClick: any
  handleSoundChange: any
  isFixed: boolean
  isMuted: boolean
}

const MIN_VALUE = 0
const MAX_VALUE = 100
const STEP_VALUE = 1

const Volume = (props: PropsType) => {
  const { className, iconClassname, soundValue, handleSoundTouchEnd, handleSoundClick, handleSoundChange, isFixed, isMuted } = props

  const [isVolumeShow, setIsVolumeShow] = useState(false)
  const [isChanging, setIsChanging] = useState(false)

  const handleVolumeMouseEnter = () => {
    setIsVolumeShow(true)
  }

  const handleVolumeMouseLeave = () => {
    setIsVolumeShow(false)
  }

  const handleChangeStart = () => {
    setIsChanging(true)
  }
  const handleChangeComplete = () => {
    setTimeout(() => {
      setIsChanging(false)
    }, 200)
  }

  return (
    <div className={cx('volume', 'no-drag', className)} onMouseEnter={handleVolumeMouseEnter} onMouseLeave={handleVolumeMouseLeave}>
      <div onTouchEnd={handleSoundTouchEnd} onClick={handleSoundClick}>
        <ActionIcon className={cx('volume-icon', iconClassname, { 'volume-icon--muted': isMuted })} icon={isMuted ? Icon.SoundOff : Icon.Sound} />
      </div>

      {!isFixed && !isMobile2 && (
        <div className={cx('volume-range', { isShow: isVolumeShow || isChanging, isMax: soundValue === MAX_VALUE && !isMobile2 && !isMuted })}>
          <Slider
            min={MIN_VALUE}
            max={MAX_VALUE}
            step={STEP_VALUE}
            value={isMuted ? MIN_VALUE : soundValue}
            orientation='vertical'
            onChange={handleSoundChange}
            tooltip={false}
            onChangeStart={handleChangeStart}
            onChangeComplete={handleChangeComplete}
          />
        </div>
      )}
    </div>
  )
}

export default Volume
